import { ReactNode } from 'react';
import cls from 'classnames';

import useStyles from './styles';

interface ILayoutForTextApps {
  className?: string;
  stickyInputChild: ReactNode;
  sidebarChild: ReactNode;
  listingChild: ReactNode;
  listingBarChild: ReactNode;
  children: ReactNode;
  preHeadlineChild?: ReactNode;
  stickyOffset?: number;
}

function LayoutForTextApps({
  stickyOffset,
  stickyInputChild,
  listingBarChild,
  sidebarChild,
  listingChild,
  preHeadlineChild,
  children,
  className,
}: ILayoutForTextApps) {
  const styles = useStyles();

  return (
    <div className={cls(styles.main, className)}>
      <div className={cls(styles.mainContainer, 'lfta-main-container')}>
        {stickyInputChild}

        <div className={styles.mainContent}>
          <div className={styles.mainContentSidebar}>
            <div className={styles.mainContentSidebarSticky}>{sidebarChild}</div>
          </div>

          <div className={styles.mainContentResults}>
            <div className={styles.mainContentBar} style={{ top: stickyOffset }}>
              {preHeadlineChild}
              <div className={styles.mainContentBarContent}>{listingBarChild}</div>
            </div>

            {listingChild}
          </div>
        </div>
      </div>
      <div className={cls(styles.landing, 'lfta-landing')}>{children}</div>
    </div>
  );
}

export default LayoutForTextApps;
